function isLocalhost() {
    return window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "::1";
}
module.exports = {
    isLocalhost
}